import { Button, Icon } from '@rneui/themed'
import PropTypes from 'prop-types'
import { Dimensions, Modal, StyleSheet, TouchableWithoutFeedback, View } from 'react-native'

import Text from '@src/components/Text'
import { colors, fonts } from '@src/config/theme'

const { height } = Dimensions.get('screen')

const FeeInformationModal = ({ visible, onClose }) => (
  <Modal transparent visible={visible} animationType="none" onRequestClose={onClose}>
    <TouchableWithoutFeedback onPress={onClose}>
      <View style={{ ...StyleSheet.absoluteFill, ...styles.container }}>
        <TouchableWithoutFeedback>
          <View style={styles.content}>
            <View style={styles.icon}>
              <Icon
                color={colors.secondary}
                size={40}
                type="orfi"
                name="fees"
                iconStyle={styles.icon}
              />
            </View>
            <View style={styles.texts}>
              <Text style={styles.comment}>
                To help you and your organisation get through COVID-19, we have temporarily removed
                all transaction fees.
              </Text>
            </View>

            <Button
              title="Thank you!"
              onPress={onClose}
              containerStyle={styles.gradientButtonContainer}
              titleStyle={styles.gradientButtonText}
              buttonStyle={styles.gradientButtonStyle}
            />
          </View>
        </TouchableWithoutFeedback>
      </View>
    </TouchableWithoutFeedback>
  </Modal>
)

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#1119',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    width: '80%',
    borderRadius: 6,
    padding: 20,
    shadowOffset: { width: 2, height: 2 },
    shadowColor: 'black',
    shadowOpacity: 0.2,
    backgroundColor: colors.white,
    marginTop: height / 5,
    alignItems: 'center',
  },
  texts: {
    paddingHorizontal: 10,
    alignItems: 'center',
  },
  icon: {
    marginVertical: 18,
    lineHeight: 40,
  },
  percentText: {
    position: 'absolute',
    top: 0,
    fontFamily: fonts.default.bold,
  },
  title: {
    color: colors.secondary,
    fontSize: 12,
    fontFamily: fonts.default.bold,
    textAlign: 'center',
  },
  comment: {
    margin: 10,
    color: colors.secondary,
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 20,
    lineHeight: 17,
  },
  gradientButtonStyle: {
    borderRadius: 23,
    height: 42,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 0,
  },

  gradientButtonContainer: {
    height: 42,
    width: '80%',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  gradientButtonText: {
    fontSize: 12,
    fontFamily: fonts.default.semiBold,
  },
})

FeeInformationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default FeeInformationModal
